import { render } from "./MailToUs.vue?vue&type=template&id=48491aba&scoped=true&ts=true"
import script from "./MailToUs.vue?vue&type=script&lang=ts"
export * from "./MailToUs.vue?vue&type=script&lang=ts"

import "./MailToUs.vue?vue&type=style&index=0&id=48491aba&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48491aba"]])

export default __exports__